import { NextRouter } from "next/router";
import { EntityProps } from "../@types/enrollments";

const handleToEnrollmentContent = ({
  context,
  entity,
  router,
  toLesson = true,
}: handleToEnrollmentContentProps) => {
  switch (context) {
    case "course":
      if (toLesson) {
        const moduleSlug = entity?.first_module_slug;
        const lessonSlug = entity?.first_lesson_slug;

        if (moduleSlug && lessonSlug) {
          router.push(`/courses/${entity?.slug}/${moduleSlug}/${lessonSlug}`);
        } else {
          router.push(`/courses/${entity?.slug}?`);
        }
      }
      break;

    case "media_space_content":
      router.push(`/media/${entity?.slug}?`);
      break;

    default:
      break;
  }
};

export default handleToEnrollmentContent;

interface handleToEnrollmentContentProps {
  context: string;
  entity: EntityProps;
  toLesson?: boolean;
  router: NextRouter;
}
